import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Switch from '@basic/Switch';
import PackagesIcon from '@components/icons/PackagesIcon';
import { setupForDark } from '@theme';

function PackagesFilterRow({
  showPackages,
  onShowPackagesChange
}: {
  showPackages: boolean;
  onShowPackagesChange: (value: boolean) => void;
}) {
  const { t } = useTranslation();

  return (
    <div
      data-testid='packages-filter-row'
      className='flex items-center gap-xs px-sm sm:px-xxl pb-sm'
    >
      <Switch value={showPackages} onChange={onShowPackagesChange} />
      <PackagesIcon size={24} className={setupForDark('text-primary')} />
      <span className={classNames(setupForDark('text-primary'), 'P3M')}>
        {t('components.packagesFilterRow.toggleLabel')}
      </span>
    </div>
  );
}

export default PackagesFilterRow;
